// extracted by mini-css-extract-plugin
export default {"rt-SegmentedControlRoot":"cCLZnYFMsFyB_rfxj7wa","rt-SegmentedControlItemLabel":"mNkwm7ChCPA9aD7vUtEP","rt-SegmentedControlItemLabelInactive":"MSUg19rvGx8FoV80xGpL"};